"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Tue May 21 2019
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author BPo
 */


var DummyWindowAppendDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(DummyWindowAppendDTOConverter, _DataObjectConverter_);

  function DummyWindowAppendDTOConverter() {
    _classCallCheck(this, DummyWindowAppendDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(DummyWindowAppendDTOConverter).apply(this, arguments));
  }

  return DummyWindowAppendDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.DummyWindowAppendDTOConverter = DummyWindowAppendDTOConverter;